export default __webpack_public_path__ + "static/media/smart.fec97bc6.png";